export const POPUP_ANIMATION_OFFSET_PIXELS = 12;
